<template>
    <div class="player-container" @contextmenu.prevent="menuPlayer()">
      <video-player class="vjs-custom-skin"
                    :options="playerOptions"
                    @play="onPlayerPlay($event)"
                    @timeupdate="onPlayerTimeupdate($event)"
                    @ended="onPlayerEnded($event)"
      >
<!--        @pause="onPlayerPause($event)"-->
<!--        @waiting="onPlayerWaiting($event)"-->
<!--        @playing="onPlayerPlaying($event)"-->
<!--        @loadeddata="onPlayerLoadeddata($event)"-->
<!--        @canplay="onPlayerCanplay($event)"-->
<!--        @canplaythrough="onPlayerCanplaythrough($event)"-->
<!--        @statechanged="playerStateChanged($event)"-->
<!--        @ready="playerReadied"-->
      </video-player>
    </div>
</template>

<script>
//引入video样式
import 'video.js/dist/video-js.css'
// import 'video.js/dist/lang/zh-CN'
// import '@/plugins/I18n/zh-CN.js'
// import videojs from 'video.js'
import 'vue-video-player/src/custom-theme.css'




//引入hls.js
import 'videojs-contrib-hls.js/src/videojs.hlsjs'
import {verifyVideoAndPlay} from '@/api/videoDetail'
export default {
  name: 'myPlayer',
  data () {
    return {
		playerOptions: {
	        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
	        autoplay: false, //如果true,浏览器准备好时开始回放。
	        controls: true, //控制条
	        preload: 'auto', //视频预加载
	        muted: false, //默认情况下将会消除任何音频。
	        loop: false, //导致视频一结束就重新开始。
          language: 'abc',
	        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
	        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
	        sources: [{
	          	type: 'video/mp4',
	          	// src: 'https://video-dev.github.io/streams/x36xhzz/x36xhzz.m3u8'
	          	src: ''
	          	// src: 'http://localhost:8100/helen/1567492475FInnsHf4gH4r0v173547.mp4'
	        }],
	        //poster: "http://static.smartisanos.cn/pr/img/video/video_03_cc87ce5bdb.jpg", //你的封面地址
	        poster: "", //你的封面地址
	        width: document.documentElement.clientWidth,
	        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: true,
            fullscreenToggle: true  //全屏按钮
          }
	      },
      // baseUrl:'http://localhost:8100/helen/'
	    }
  },
  props:[
    'id'
  ],

  mounted() {

  },
  created(){
    this.verifyVideo()
  },
  methods: {
    onPlayerPlay(player) {
    },
    onPlayerTimeupdate(player){
      const time  = player.currentTime()
      if (time > 5){
        // player.load()
      }
    },
    onPlayerEnded(player) {
      console.log('player ended!', player)
    },
    verifyVideo(){
      verifyVideoAndPlay(this.id).then(res=>{
        if (res.code===20000){
          this.playerOptions.sources[0].src = this.baseUrl + res.data.url
          this.playerOptions.poster = this.baseUrl + res.data.picUrl
        }
      })
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/player.scss";
</style>



// WEBPACK FOOTER //
// src/components/myPlayer.vue